<template>
  <div class="pages">
    <!-- <div class="container detail" v-html="language=== 'en' ? datas.enContent : language=== 'ru' ? datas.enContent : datas.content"></div> -->
    <div class="container aboutUs">
      <div class="images">
        <img src="../../assets/tianshi/lxus.jpg" alt />
      </div>
      <div class="inform">
        <div class="titl1">{{ language =="ru" ? '. لا بأس، لا بأس -':language =="zh" ? '联系信息':'Contact Information' }}</div>
        <div
          class="titl2"
        >{{ language =="ru" ? '. لا بأس، لا بأس -':language =="zh" ? '多为自身思考，多为自身努力，方能收获更多美好。':'Think MOre For You,Do Better For You' }}</div>
        <div class="titl3">{{$t("mobile1")}}：{{ getSetting.telPhone }}</div>
        <div class="titl3">{{$t("mobile")}}：{{ getSetting.mobile }}</div>
        <div class="titl3">{{ $t("companyFax") }} ：{{ getSetting.fax }}</div>
        <div class="titl3">{{ $t("companyMail") }}：{{ getSetting.homeMail }}</div>
        <div class="titl3">
          {{ $t("companyAddress") }}：
          {{ $t('language') === "English" ? getSetting.enAddress :
          $t('language') === "الصينية" ? getSetting.rusAddress : getSetting.address }}
        </div>
      </div>
    </div>
    <div class="container submit">
      <div class="submit-title">{{ language =="ru" ? 'قدم طلب الشراء الخاص بك':language =="zh" ? '提交您的采购申请':'Submit Your Sourcing Request' }}</div>
      <div
        class="submit-title1"
      >{{ language =="ru" ? `يرجى ملء تفاصيل احتياجاتك في هذا الجدول، وسيتصل بكم فريق الدعم الفني لدينا في أقرب وقت ممكن. سنقوم بتعيين متخصص `:language =="zh" ? '请在此表格中填写您的详细需求，我们的客户支持团队将会尽快与您取得联系。我们将指派专业人员跟进您的项目，并为您提供服务。':'Fill out this form with your detailed needs and our customer support team will contact you shortly. We will assign a professional staff to follow up on your project and provide' }}</div>
      <div class="submit-title1">{{ language =="ru" ? 'لتابع مشروعك وتقديم الخدمة لكم.':language =="zh" ? '个性化服务。':'personalized assistance.' }}</div>
      <div
        class="submit-title1"
      >{{ language =="ru" ? 'للحصول على أسرع رد، يرجى تقديم استفسارك من خلال هذا النموذج. إذا واجهت أي مشكلة أثناء التقديم، يمكنك أيضًا الاتصال بنا مباشرة عبر البريد الإلكتروني على العنوان التالي:':language =="zh" ? '为了获得最快的回复，请通过该表格提交您的咨询。如果您在提交过程中遇到任何问题，也可以直接通过电子邮件与我们联系，邮箱地址为':'To get the fastest response, submit your inquiries using the form. If you encounter any issues with submission, you can also email us directly at ' }} {{ getSetting.homeMail }}.</div>
      <div class="form">
        <div class="inputbox">
          <el-input size="small" v-model="searchForm.name" :placeholder="luange('名字','First Name','المدرسة Name')"></el-input>
          <el-input size="small" v-model="searchForm.skype" :placeholder="luange('姓氏','Last Name','اسم')"></el-input>
          <el-input size="small" v-model="searchForm.email" :placeholder="luange('电子邮件','Email(required)','البريد الإلكتروني')"></el-input>
        </div>
        <div class="inputbox" style="margin-top: 19px;">
          <el-input size="small" v-model="searchForm.tel" :placeholder="luange('电话','Phone(eg.+12345678)','الهاتف')"></el-input>
          <el-input
            size="small"
            v-model="searchForm.area"
            :placeholder="luange('地址','Address for shipping samples(optional)','. (آدريس) -. أجل -')"
          ></el-input>
          <el-input
            size="small"
            v-model="searchForm.content"
            :placeholder="luange('请告诉我们您需要什么样的产品','Tell us what kind of products do you need','. لا بأس، لا بأس -')"
          ></el-input>
        </div>
        <div class="btn" @click="submitcat">{{ $t("submit") }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { getCompanyInfo } from '@/api/home'
import { Message } from '@/api/login'

export default {
  name: 'pageDetail',
  data() {
    return {
      datas: {},
      searchForm: {
        tel: "",
        name: "",
        area: "",
        email: "",
        content: "",
        skype: "",
      }
    }
  },
  computed: {
    ...mapState('operate', ['language']),
    ...mapGetters("setting", {
      getSetting: 'get_setting'
    }),
  },
  created() {
    // this.init()
  },
  methods: {
    init() {
      // 获取公司简介
      getCompanyInfo().then(res => {
        if (res.success) {
          this.datas = res.data
        }
      })
    },
    luange(zw, yw, alb) {
      return this.language == "ru" ? alb : this.language == "zh" ? zw : yw
    },
    submitcat() {
      if (!this.searchForm.name) {
        this.$message.error(this.$hs('必填姓名', 'Required name', 'Nombre requerido nombre'))
        return
      }
      if (!this.searchForm.email) {
        this.$message.error(this.$hs('电子邮箱', 'Email address', 'Correo electrónico'))
        return
      }
      if (!this.searchForm.content) {
        this.$message.error(this.$hs('必填留言内容', 'Required message content', 'Obligatorio contenido del mensaje'))
        return
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t('NT.loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Message(this.searchForm)
        .then(res => {
          if (res.success) {
            this.$message.success(this.$hs('提交成功', 'Submitted successfully', 'Presentación exitosa'))
            this.searchForm = {
              tel: "",
              name: "",
              area: "",
              email: "",
              content: "",
              skype: "",
            }
          } else {
            this.$message.error(this.$hs('提交失败', 'Submission failed', 'Presentación fallida'))
          }
        })
        .catch(err => {
          this.$message.error(JSON.stringify(err))
        })
        .finally(() => {
          loading.close()
        })
    },
  }
}
</script>
<style lang="scss" scoped>
.pages {
  background: linear-gradient(135deg, #aee7fb, #fadbea 51%, #f9e1cf);
  padding-top: 30px;
  padding-bottom: 50px;
  .aboutUs {
    height: 560px;
    background: #ffffff;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    .images {
      height: 480px;
      width: 690px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .inform {
      height: 480px;
      margin-left: 69px;
      .titl1 {
        font-size: 40px;
        font-weight: 700;
        color: #333c4f;
        margin-bottom: 28px;
      }
      .titl2 {
        font-size: 20px;
        font-weight: 400;
        color: #222222;
        margin-bottom: 39px;
      }
      .titl3 {
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        margin-bottom: 14px;
        width: 570px;
      }
    }
  }
  .submit {
    background: #ffffff;
    border-radius: 12px;
    margin-top: 24px;
    padding-bottom: 50px;
    .submit-title {
      font-size: 26px;
      font-weight: 700;
      text-align: left;
      color: #222222;
      padding-top: 50px;
      padding-left: 50px;
      margin-bottom: 16px;
    }
    .submit-title1 {
      font-size: 16px;
      font-weight: 400;
      text-align: left;
      color: #666666;
      padding-left: 50px;
      line-height: 26px;
    }
    .form {
      margin-top: 51px;
      margin-left: 50px;
      margin-right: 50px;
      .inputbox {
        display: flex;
        justify-content: space-between;
        .el-input {
          width: 431px;
        }
      }
      .btn {
        width: 1340px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #d871b8;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        margin-top: 35px;
        cursor: pointer;
      }
    }
  }
}
// .detail {
//   padding: 40px 0;

//   & img {
//     max-width: 100%;
//   }
// }
</style>
